import { useEffect, useRef } from 'react';
import { reaction } from 'mobx';
import plateRecognitionContext from 'features/eiq-secure/stores/license-plate-recognition-context';

export const useBoundPlateRecognition = (onConsumed: () => void) => {
  const callbackRef = useRef(onConsumed);
  callbackRef.current = onConsumed;

  useEffect(() => {
    const disposer = reaction(
      () => plateRecognitionContext.externalConsumptionVersion,
      () => {
        callbackRef.current();
      },
    );

    return () => disposer();
  }, []);
};
